export default function Hero() {
  return (
    <section className="relative bg-background overflow-hidden min-h-screen">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://breakthruai2.lovable.app/assets/hero-bg-Cav5BQCB.jpg" 
          alt="" 
          className="w-full h-full object-cover" 
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/60 to-background"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 lg:pt-44 pb-20 lg:pb-32">
        <div className="flex flex-col items-center text-center">
          <div className="animate-fade-in max-w-3xl">
            {/* Trust Badge */}
            <div className="flex items-center justify-center gap-2 mb-6">
              <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-teal-500/10 border border-teal-500/20">
                <span className="text-xs font-semibold text-teal-600 ml-1">Trusted across regulated industries</span>
              </div>
            </div>

            {/* Main Heading */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-display font-bold text-foreground leading-[1.1] mb-6">
              Where <span className="text-teal-600">Intelligence</span> Breaks Through
            </h1>

            {/* Subheading */}
            <p className="text-lg lg:text-xl text-muted-foreground mx-auto max-w-xl mb-10">
              BreakthruAI designs and deploys intelligent automation systems that eliminate operational friction across finance, healthcare, legal, and real estate organizations.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="group px-8 py-4 bg-teal-600 text-white font-semibold rounded-xl hover:bg-teal-700 transition-all flex items-center justify-center gap-2 text-base cursor-pointer whitespace-nowrap">
                Get a Systems Assessment
              </button>
              <button className="group px-8 py-4 bg-transparent border-2 border-foreground text-foreground font-semibold rounded-xl hover:bg-foreground hover:text-background transition-all flex items-center justify-center gap-2 text-base cursor-pointer whitespace-nowrap">
                Explore Our Solutions
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-foreground/30 flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-foreground/50 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}